// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_v6-8";
export var editMode = "_v6-3";
export var headerRow = "_v6-a";
export var headerTitle = "_v6-b";
export var product = "_v6-1";
export var productDetails = "_v6-5";
export var productDivider = "_v6-7";
export var productImage = "_v6-2";
export var productInfo = "_v6-4";
export var productTitle = "_v6-6";
export var strikethrough = "_v6-9";
export var upsellProductsCard = "_v6-0";